import { Pipe, PipeTransform, inject } from '@angular/core';
import { StaticDataService } from '@mavles/shared';

@Pipe({
    name: 'paymentMode',
    standalone: false
})
export class PaymentModePipe implements PipeTransform {
  private staticDataService = inject(StaticDataService);


  transform(value: unknown): any {
    return  this.staticDataService.appConfig.paymentModes.find(t => t.payment_mode_id === value)?.payment_mode_name;
  }

}


